export const validatePan = (panInput)=>{
    const regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    return panInput.match(regex) !== null
}
 
export const formatNumberWithCommas = (number) => {
    return number?.toLocaleString('en-IN')
  };
 